export const GET_SHIPMENTS = "GET_SHIPMENTS";
export const GET_SHIPMENT = "GET_SHIPMENT";
export const ADD_SHIPMENT = "ADD_SHIPMENT";
export const DELETE_SHIPMENT = "DELETE_SHIPMENT";
export const UPDATE_SHIPMENT = "UPDATE_SHIPMENT";
